import {clientGetWrapper} from "../api/Api"
import {GET_ALL_OFFERS} from "../common/constants/routes";


export const getAllOffers = () => {
    return clientGetWrapper(GET_ALL_OFFERS);
}


